export const LANDING_PAGE_ROUTE = 'landing-page'

export const CUSTOM_ROUTES_WO_GRS = ['parknow']
